import React, { Component, Fragment, createRef } from 'react';
import { Form } from 'react-final-form';
import { Field } from 'react-final-form-html5-validation';
import Axios from 'axios';

class UnsubscribeForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            guid: null
        }
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const contactKey = urlParams.get('ContactKey');
        this.setState({
            ...this.state,
            guid: contactKey ? contactKey : false
        })
    }
    
    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        values.formType = 'unsubscribe';
        try {
            await Axios({
                method: 'post',
                url: url + "api/unsubscribe",
                data: values,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (res) {
              reactState.setState({
                ...reactState.state,
                submitted: true
              });
            });
        }
        catch(errors) {
            console.log("errors", errors)
        }
    }

    toTop = createRef();

    render() {
        const { submitted, guid } = this.state;

        return (
            <div className="acadia-form" ref={this.toTop}>
                <Form
                    onSubmit={this.onSubmit}
                >
                    {({ form, values, submitting, pristine, handleSubmit }) => (
                        <Fragment>
                            {submitted && (
                                <Fragment>
                                    <div className="row">
                                        <h1>You have been unsubscribed</h1>
                                        <p style={{textAlign: "center", width: "100%"}}>Your information has been removed from our mailing list.<br />We are sorry to see you go.</p>
                                    </div>
                                </Fragment>
                            )}
                            {!submitted && (
                                <Fragment>
                                    <div className="row">
                                        <h1>Are you sure you want to stop receiving communications from NuplazidHCP.com?</h1>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <button className="btn align-center submit btn-default unsub-btn" style={{padding: "15px 0", width: "400px", margin: "10px auto"}} type="submit" onClick={handleSubmit} disabled={submitting}>
                                                <b>Yes, please remove me 
                                                    <svg style={{marginLeft: "5px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                                    </svg>
                                                </b>
                                            </button>
                                        </div>
                                        <div className="col-sm-12">
                                            <a 
                                                className="btn align-center submit btn-default unsub-btn"
                                                style={{padding: "15px 0", width: "400px", margin: "10px auto"}}
                                                href="/"
                                            >
                                               <b>Never mind, please keep me on <br className="d-block d-sm-none" />the&nbsp;mailing&nbsp;list
                                                    <svg style={{marginLeft: "5px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                                    </svg>
                                               </b>
                                            </a>
                                        </div>
                                        <Field className="form-control full-width-input" name="guid" component="input" defaultValue={guid}>
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input {...input}  type="text" style={{opacity: 0, height:"0px"}} tabIndex="-1" />
                                                </Fragment>
                                            )}
                                        </Field>
                                    </div>
                                </Fragment>
                            )}
                            {process.env.NODE_ENV === "development" && (
                                <pre style={{marginTop: "50px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
                            )}            
                        </Fragment>                                                                       
                    )}           
                </Form>
            </div>
        );
    }
}

export default UnsubscribeForm;